/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useCookieConsent } from "../provider/CookieConsent/CookieConsentProvider";
import { useEffect } from "react";
import { gaInitialize, gaSet, gaTerminate } from "../services/googleAnalyticsService";

export default function useGoogleAnalytics() {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasConsent("analytics")) {
      gaTerminate();
      return;
    }

    gaInitialize();
    gaSet({ anonymizeIp: false });
  }, [hasConsent]);
}
